import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slide from 'react-reveal/Slide';

import './sidebar.scss';
import MenuLink from '../menuLink';
import salom_logo from '../../../../shared/assets/images/salom.png';
import IconAlifDash from '../../../../components/icon/IconAlifDash';

class Sidebar extends Component {
  role = localStorage.getItem('salom::admin::role');

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Slide left>
        <div
          className="sidebar-content"
          style={{
            transition: 'all .2s ease-in-out',
            marginLeft: this.props && this.props.toggle ? '-290px' : '',
          }}
        >
          <nav className="sidebar">
            <div className="sidebar-header">
              {/* <span><i className="fa fa-circle text-info"></i> Shahrom Kurbonov</span> */}
              <Link to="/admin">
                <IconAlifDash />
              </Link>
            </div>
            <div className="links-content">
              <ul className="nav-list">
                <MenuLink
                  activeOnlyWhenExact={true}
                  to="/admin"
                  label="Статистика"
                />
                {/* <MenuLink to="/admin/categories" label="Категории" /> */}
                {/* <MenuLink to="/admin/partners" label="Партнеры" /> */}
                {/* <MenuLink to="/admin/cities" label="Города" /> */}
                {/* <MenuLink to="/admin/periods" label="Периоды" /> */}
                {/* <MenuLink to="/admin/feedbacks" label="Отзывы" /> */}
                {/* <MenuLink to="/admin/faq" label="FAQs" /> */}
                <MenuLink to="/admin/applications" label="Заявки" />
                {/* <MenuLink to="/admin/partners_applications" label="Заявки партнеров" /> */}
                {/* <MenuLink to="/admin/recomended_partners" label="Рекомендуемые маг." /> */}
                {this.role === 'admin' ? (
                  <MenuLink to="/admin/users" label="Пользователи" />
                ) : (
                  ''
                )}
              </ul>
            </div>
          </nav>
          <div className="sub-sidebar">
            <ul className="nav-list">
              <li className="nav-item">
                <Link to="/" className="nav-link">
                  <i className="fa fa-home"></i> Перейти на сайт
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/login" className="nav-link">
                  <i className="fa fa-power-off"></i> Выйти
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </Slide>
    );
  }
}

export default Sidebar;
